import * as React from "react";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { useRef } from "react";
import { useState } from "react";

export function Alerts({ message, rigor }) {
  return (
    <Stack className="textstars" spacing={2}>
      <div style={{ width: "fit-content", margin: "0.5rem 0 0 0.5rem" }}>
        <Alert
          className={message === "Satisfactoria" || message === "Fácil" ? "gray" : ""}
          style={{
            fontWeight: "bold",
            fontSize: "1.1rem",
            padding: "0 0.5rem",
            borderRadius: "6px",
          }}
          icon={false}
          variant="filled"
          severity={rigor || "error"}
        >
          {message || "Muy Insatisfecho"}
        </Alert>
      </div>
    </Stack>
  );
}
